import React, { useState, useEffect } from "react";
import Styles from "./IncidentModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { IncidentReportPost } from "../../redux/admin/actions/admin.actions";

const IncidentModal = ({ setIncident, incident }) => {
  const [reason, setReason] = useState("");
  const [isReasonEmpty, setIsReasonEmpty] = useState(false);
  const { id } = incident;
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setReason(e.target.value);
    setIsReasonEmpty(e.target.value === "");
  };

  const handleProcess = () => {
    // if (isReasonEmpty !== false) {
    //   console.log("isReasonEmptyeee", isReasonEmpty);
    //   // Only proceed if the field is not empty
    //   const data = {
    //     id: id,
    //     reason: reason,
    //   };
    //   dispatch(IncidentReportPost({ data }));
    //   setReason("");
    //   // setIncident(false);
    // }
    setIsReasonEmpty(reason === ""); 
    if (reason !== "") {
      const data = {
        id: id,
        reason: reason,
      };
      dispatch(IncidentReportPost({ data }));
      setReason("");
      setIncident(false);
    }
  };

  const Closemodal = () => {
    setIncident(false);
  };

  return (
    <div className={Styles.modal}>
      <div className={Styles.modalContent}>
        <div className={Styles.modalClose}>
          <h4 className={Styles.cancel} onClick={Closemodal}>
            X
          </h4>
        </div>
        <h2>Incident Report </h2>
        <div className={Styles.reason}>
          <label>What is the reason?</label>
          <textarea
            placeholder="Reason"
            value={reason}
            onChange={handleChange}
            className={Styles.textarea}
          />
          {isReasonEmpty && (
            <div className={Styles.error}>Field cannot be empty</div>
          )}
        </div>
        <div style={{ justifyContent: "center" }}>
          <button
            onClick={handleProcess}
            className={`${Styles.btn} ${
              isReasonEmpty ? Styles["btn-disabled"] : ""
            }`}
            disabled={isReasonEmpty}
          >
            Process
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncidentModal;
